import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const ArchiveSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default ArchiveSVG;
